module.exports = __webpack_public_path__ + "static/media/Space-Logo-Animation.670ed7e2.gif";